<template>
  <el-aside :class="getMenuClass" width="70px">
    <el-menu v-if="!isShowMenu" class="more-button">
      <el-menu-item index="show-menu" @click="showMenu">
        <i class="material-icons md18 color_gray rotate">
          more_horiz
        </i>
      </el-menu-item>
    </el-menu>
    <el-menu v-if="isShowMenu" class="less-button">
      <el-menu-item index="show-menu" @click="showMenu">
        <i class="material-icons md18 color_gray rotate">
          close
        </i>
      </el-menu-item>
    </el-menu>
    <el-menu router :default-active="$route.path" active-text-color="#5e6d82">
      <template v-for="(item, index) in menuList">
        <el-tooltip :content="item.meta.title" placement="right" :key="index">
          <el-menu-item :index="item.path" @click="showMenu">
            <i class="material-icons md18 color_grey">
              {{item.meta.icon}}
            </i>
            <span v-if="item.meta.icon == 'queue' && newRequestsCount > 0" class="notify"> {{newRequestsCount}}</span>
          </el-menu-item>
        </el-tooltip>
      </template>
      <el-menu-item index="exit" @click="logOut">
        <i class="material-icons md18 color_gray rotate">
          exit_to_app
        </i>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
/*
  el-aside based navigation component
*/

// vuex
import {mapGetters} from "vuex";

// store
import { AUTH_LOGOUT } from "../store/actions/auth";
import { NEW_REQUESTS_COUNT } from "../store/actions/manager";

// routes
import {routes} from '../router.js';

export default {
  name: 'Navigation',
  data() {
    return {
      isShowMenu: false
    };
  },
  computed: {
    ...mapGetters([
      'userRole',
      'userGroup',
      'userId',
      'newRequestsCount'
    ]),
    menuList() {
      let list = [];
      routes.forEach(item => {
        if (item.children) {
          item.children.forEach(itemChildren => {
            if ((itemChildren.meta.roles.includes(this.userRole) && itemChildren.meta.showInMenu) || itemChildren.meta.roles.includes(this.userGroup) || itemChildren.meta.roles.includes(this.userId)) {
              list.push(itemChildren);
            }
          })
        }
      });
      if (this.userId == "1028" || this.userId == "1075" || this.userGroup == '2001' || this.userGroup == '2002' || this.userGroup == '2003' || this.userGroup == '2004' || this.userGroup == '2005' || this.userGroup == '2006' || this.userGroup == '2007' || this.userGroup == '2008' || this.userGroup == '2009' || this.userGroup == '2010')
        setInterval(() => this.$store.dispatch(NEW_REQUESTS_COUNT), 50000)
      return list;
    },
    getMenuClass() {
      return this.isShowMenu ? 'aside-menu aside-menu--show' : 'aside-menu';
    }
  },
  methods: {
    logOut() {
      localStorage.clear();
      this.$store.dispatch(AUTH_LOGOUT);
    },
    showMenu() {
      this.isShowMenu = !this.isShowMenu;
    },
  }
}
</script>

<style>
  .el-aside {
    min-height: 100vh;
  }

  .el-menu {
    border-color: transparent;
    position: fixed;
    height: 100vh;
  }

  .aside-menu {
    position: relative;
  }
  .more-button {
    display: none;
    position: absolute;
    right: -60px;
    height: unset;
  }

  .less-button {
    display: none;
    position: absolute;
    left: 60px;
  }

  .el-menu-item.is-active {
    color: #409EFF!important;
    background-color: #ecf5ff;
}

  @media screen and (max-width: 480px) {
    .aside-menu {
      overflow: visible;
      position: absolute;
      z-index: 200;
      left: -70px;
      background-color: #fff;

    }
      .el-menu-item {
          max-width: 65px;
      }


    .aside-menu--show {
      left: 0;
      -webkit-box-shadow: 12px 0px 39px -22px rgba(34, 60, 80, 0.2);
      -moz-box-shadow: 12px 0px 39px -22px rgba(34, 60, 80, 0.2);
      box-shadow: 12px 0px 39px -22px rgba(34, 60, 80, 0.2);
    }

    .more-button {
      display: block;
    }

    .less-button {
      display: block;
      background: #fff;
      height: 100vh;
      position: fixed;
      box-shadow: 0 8px 120px rgba(0,0,0,.3);
    }
  }
  .notify{
    color: #409EFF;
    margin-left: 2px;
    background: #40a0ff30;
    padding: 1px 3px;
    border-radius: 3px;
  }
</style>
